import type { Locale } from '@/config/i18n/locales';
import { COLORS } from './colors';
import CzechiaFlag from '@/assets/svg/flags/Czechia.svg';
import GermanyFlag from '@/assets/svg/flags/Germany.svg';
import UnitedKingdomFlag from '@/assets/svg/flags/UnitedKingdom.svg';
import SpainFlag from '@/assets/svg/flags/Spain.svg';
import FranceFlag from '@/assets/svg/flags/France.svg';
import CroatiaFlag from '@/assets/svg/flags/Croatia.svg';
import ItalyFlag from '@/assets/svg/flags/Italy.svg';
import HungaryFlag from '@/assets/svg/flags/Hungary.svg';
import PolandFlag from '@/assets/svg/flags/Poland.svg';
import RussiaFlag from '@/assets/svg/flags/Russia.svg';
import RomaniaFlag from '@/assets/svg/flags/Romania.svg';
import AlbaniaFlag from '@/assets/svg/flags/Albania.svg';
import SloveniaFlag from '@/assets/svg/flags/Slovenia.svg';
import SlovakiaFlag from '@/assets/svg/flags/Slovakia.svg';
import TurkeyFlag from '@/assets/svg/flags/Turkey.svg';

type SvgWithSrc = { src: string };

export const localeToFlag: Partial<Record<Locale, SvgWithSrc>> = {
  cs: CzechiaFlag,
  de: GermanyFlag,
  en: UnitedKingdomFlag,
  es: SpainFlag,
  fr: FranceFlag,
  hr: CroatiaFlag,
  it: ItalyFlag,
  hu: HungaryFlag,
  pl: PolandFlag,
  ru: RussiaFlag,
  ro: RomaniaFlag,
  sq: AlbaniaFlag,
  sl: SloveniaFlag,
  sk: SlovakiaFlag,
  tr: TurkeyFlag,
};

export const DROPDOWN_LOCALES_ORDERED: Locale[] = [
  'cs',
  'de',
  'en',
  'es',
  'fr',
  'hr',
  'it',
  'hu',
  'pl',
  'ru',
  'ro',
  'sq',
  'sl',
  'sk',
  'tr',
];

export const dropdownLocales = DROPDOWN_LOCALES_ORDERED.filter((loc) => localeToFlag[loc]);

export const WRAPPER_SX = { display: 'flex', alignItems: 'center' } as const;

export const FLAG_IMG_SX = {
  width: 18,
  height: 18,
  borderRadius: '50%',
  display: 'block',
} as const;

export const EXPAND_ICON_SX = {
  fontSize: 18,
  color: COLORS['primary/700'],
  '@media (max-width: 1019px)': { color: COLORS['secondary/700'] },
} as const;

export const BUTTON_SX = {
  minWidth: 'auto',
  textTransform: 'none',
  padding: '0px 10px',
  height: '38px',
  columnGap: '6px',
  color: COLORS['primary/700'],
  fontFamily: '"Plus Jakarta Sans"',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '16px',
  '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
  '& .MuiButton-startIcon': { mr: '0px' },
  '& .MuiButton-endIcon': { ml: 0, color: COLORS['primary/700'] },
  '@media (max-width: 1019px)': {
    color: COLORS['secondary/700'],
    '& .MuiButton-endIcon': { color: COLORS['secondary/700'] },
  },
} as const;

export const MENU_LIST_PROPS = { 'aria-labelledby': 'language-switcher-button' } as const;

export const MENU_PAPER_PROPS = {
  sx: { borderRadius: 2, overflow: 'hidden' },
} as const;

export const MENU_ANCHOR_ORIGIN = { vertical: 'bottom', horizontal: 'right' } as const;

export const MENU_TRANSFORM_ORIGIN = { vertical: 'top', horizontal: 'right' } as const;

export const MENU_ITEM_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.2,
  py: 1,
  px: 2,
  mx: 1,
  borderRadius: 2,
  '&.Mui-selected': {
    backgroundColor: 'rgba(238, 230, 225, 0.65)',
  },
  '&.Mui-selected:hover': {
    backgroundColor: 'rgba(238, 230, 225, 0.65)',
  },
} as const;

export const MENU_ITEM_INNER_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.2,
} as const;

export const MENU_ITEM_LABEL_SELECTED_SX = {
  color: COLORS['secondary/700'],
  fontFamily: '"Plus Jakarta Sans"',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '16px',
} as const;

export const MENU_ITEM_LABEL_SX = {
  color: COLORS['neutral/950'],
  fontFamily: '"Plus Jakarta Sans"',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '16px',
} as const;
